<script setup>
defineProps({
  selected: { type: Boolean, default: false },
  icon: { type: [Object, Function], default: null },
  /** light for cream and white surfaces, dark for ink surfaces */
  surface: { type: String, default: 'light' },
});
defineEmits(['click']);
</script>

<template>
  <button
    type="button"
    class="pd-chip"
    :class="[`pd-chip--${surface}`, { 'is-on': selected }]"
    :aria-pressed="selected"
    @click="$emit('click')"
  >
    <component :is="icon" v-if="icon" :size="16" :stroke-width="2.25" aria-hidden="true" />
    <slot />
  </button>
</template>

<style scoped>
.pd-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: var(--pd-r-pill);
  border: 0;
  background: var(--pd-neutral);
  font-weight: 750;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color var(--pd-fast) var(--pd-ease);
}
.pd-chip--light { color: var(--pd-ink); }
.pd-chip--dark { color: var(--pd-white); background: var(--pd-ink-3); }
@media (hover: hover) {
  .pd-chip--light:hover:not(.is-on) { background: var(--pd-neutral-hover); }
  .pd-chip--dark:hover:not(.is-on) { background: #383838; }
}
.pd-chip.is-on { background: var(--pd-orange); border-color: var(--pd-orange); color: var(--pd-on-orange); }
</style>
